import React from "react";
import { motion } from "framer-motion";
import { styles } from "../styles";

const AboutUs = ({ animations, isMobile }) => {
  return (
    <motion.section
      id="about-us"
      initial="initial"
      whileInView="animate"
      viewport={{ once: true, amount: 0.2, margin: "-100px" }}
      className="relative py-16 md:py-24 bg-cover bg-center"
      style={{
        backgroundImage: "url('images/landing/about-bg.jpg')",
        backgroundAttachment: isMobile ? "scroll" : "fixed",
      }}
    >
      <div className={`${styles.overlay} bg-white/90`} />
      <div
        className={`relative ${styles.container} grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12`}
      >
        <motion.img
          variants={animations.slideIn}
          src="/images/landing/about.png"
          alt="About Us"
          className="rounded-lg w-full shadow-xl"
          loading="lazy"
        />
        <motion.div
          variants={animations.fadeInUp}
          className="flex flex-col justify-center"
        >
          <h2 className={`${styles.sectionTitle} text-primary mb-6 md:mb-8`}>
            About Us
          </h2>
          <div className="text-gray-700 space-y-4">
            <p className="text-sm md:text-base lg:text-lg">
              PT Adhim Aju Sejahtera perusahaan bergerak dibidang pengendalian
              struktur baja dengan system cathodic protection. PT Adhim Aju
              Sejahtera memiliki Sumberdaya Manusia Unggul dibidangnya serta
              memiliki pengalaman dalam penanganan masalah korosi melalui sistem
              proteksi katodik.
            </p>
            <p className="text-sm md:text-base lg:text-lg">
              PT Adhim Aju Sejahtera Tekhnik menjalankan bisnisnya dengan penuh
              profesionalitas dan didukung oleh kemampuan manajerial yang
              handal.{" "}
              <a href="/about" className="text-primary hover:text-primary-dark">
                Read More
              </a>
            </p>
          </div>
        </motion.div>
      </div>
    </motion.section>
  );
};

export default AboutUs;
